import React from 'react';
import { Code } from '@components/sanity/serializers/code';
import classNames from 'classnames';
import Image from 'next/legacy/image';

type TProps = {
  imagePosition?: 'left' | 'right';
  userProfile: string;
};

export const SimpleUserProfile: React.FC<TProps> = props => {
  let { imagePosition } = props;
  const { userProfile } = props;
  if (!imagePosition) {
    imagePosition = 'right';
  }

  return (
    <>
      <div className="py-8 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
        <div
          className={classNames(
            'mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:px-0',
            imagePosition === 'right' ? 'lg:col-start-1' : 'lg:col-start-2'
          )}
        >
          <div>
            <div className="mt-6">
              <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                {'<UserProfile />'}
              </h2>
              <p className="text mt-4 text-gray-500">
                A place for your users to change their password, turn on
                multifactor auth, revoke bad sessions, and more. Every app
                should offer the best security options, so every user can be
                safe.
              </p>
              <Code language="jsx" theme="dark" highlightedLines={undefined}>
                {userProfile}
              </Code>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            'mx-auto flex max-w-xl items-center justify-center px-8',
            imagePosition === 'right' ? 'lg:col-start-2' : 'lg:col-start-1'
          )}
        >
          <Image
            className="w-full object-cover "
            src="/images/components/user-profile-full.svg"
            alt="user-profile-full"
            width={496}
            height={334}
          />
        </div>
      </div>
    </>
  );
};

SimpleUserProfile.defaultProps = {
  imagePosition: undefined
};

export default SimpleUserProfile;
